"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeChargerControlUIScreenStatusState = exports.serializeChargerControlTransactionStatusState = exports.serializeChargerControlPricingState = exports.serializeChargerControlOcppAuthorizedTransactionsState = exports.serializeChargerControlCtepParameterLogState = exports.serializeChargerControlCloudChargerOperatingStatusState = exports.serializeChargerControlChargingState = exports.serializeChargerControlChargerStatusState = exports.serializeChargerControlChargerConfigurationState = exports.serializeChargerControlActiveTransactionsState = exports.serializeChargerControlActiveSessionAttemptsState = exports.serializeUseMembershipAsPaymentEvent = exports.serializeStopChargingSessionRequestEvent = exports.serializeSksgV2RebootCommandEvent = exports.serializeSksgV2FirmwareUpdateCommandEvent = exports.serializeSkipMembershipValidationEvent = exports.serializeSimPaymentTerminalControlPaymentEvent = exports.serializeSimChargerControlPluggedInEvent = exports.serializeSimChargerControlErrorCodeEvent = exports.serializeSimChargerControlDeratingReasonEvent = exports.serializeRequestOcppIdTokenAuthorizationEvent = exports.serializeRequestMembershipValidationEvent = exports.serializeRegisterMemberIdentifierEvent = exports.serializeReceivedOcpiTrackingIdEvent = exports.serializePaymentTerminalControlRequestCardPaymentCaptureEvent = exports.serializePaymentTerminalControlPaymentCompletedEvent = exports.serializePaymentTerminalControlEMVCardPayloadEvent = exports.serializePaymentPresentedEvent = exports.serializePaymentExpiredEvent = exports.serializePaymentCaptureErrorEvent = exports.serializePaymentCaptureDeferredEvent = exports.serializePaymentCancelledEvent = exports.serializePaymentAuthorizedEvent = exports.serializePaymentAuthorizationErrorEvent = exports.serializeOcppIdTokenAuthorizationResolvedEvent = exports.serializeMembershipValidatedEvent = exports.serializeMembershipPresentedEvent = exports.serializeMembershipErrorEvent = exports.serializeGenerateReceiptEvent = exports.serializeDiscoControlManualCommandEvent = exports.serializeCoolioManualCommandEvent = exports.serializeConfirmMembershipInformProceedEvent = exports.serializeChargingTransactionCompletedEvent = exports.serializeChargerUISendOnScreenValidationFeedbackEvent = exports.serializeChargerUISendFeedbackEvent = exports.serializeChargerUIChangeActivePortEvent = exports.serializeChargerControlPluggedInEvent = exports.serializeCancelTransactionEvent = exports.StateTopics = exports.EventTopics = void 0;
exports.serializeStateByEntityType = exports.serializeEventByEntityType = exports.serializeTestRackRelayStatusState = exports.serializeTestRackRelayCommandState = exports.serializeTestRackPowerSourceStatusState = exports.serializeTestRackPowerSourceCommandState = exports.serializeTestRackPowerSinkStatusState = exports.serializeTestRackPowerSinkCommandState = exports.serializeTestRackEvStatusState = exports.serializeTestRackEvGpioCommandState = exports.serializeSimDispenserControlSafetyMicroState = exports.serializeSimDispenserControlHvPsState = exports.serializeSimDispenserControlEvseCommandsState = exports.serializeReceiptChargingSessionAttemptsState = exports.serializePaymentTerminalControlTerminalStatusState = exports.serializePaymentTerminalControlProcessingPaymentsState = exports.serializePaymentTerminalControlPresentedPaymentsState = exports.serializePaymentTerminalControlPendingPreauthsState = exports.serializePaymentTerminalControlMetricsState = exports.serializePaymentTerminalControlCompletedPaymentsState = exports.serializePaymentTerminalControlCachedPaymentMethodState = exports.serializePaymentTerminalControlActivePaymentsState = exports.serializePaymentTerminalControlActiveMembershipsState = exports.serializeChargingTransactionTelemetryTrackerState = exports.serializeChargingSessionTrackerState = exports.serializeChargerUIStatusState = exports.serializeChargerUIFullscreenTakeoverState = exports.serializeChargerUIActivePortState = void 0;
const serialization_1 = require("../serialization");
const __1 = require("../../..");
/**
 * Topic name constants for events and states.
 */
exports.EventTopics = {
    CancelTransaction: "Event_CancelTransaction",
    ChargerControlPluggedIn: "Event_ChargerControlPluggedIn",
    ChargerUIChangeActivePort: "Event_ChargerUIChangeActivePort",
    ChargerUISendFeedback: "Event_ChargerUISendFeedback",
    ChargerUISendOnScreenValidationFeedback: "Event_ChargerUISendOnScreenValidationFeedback",
    ChargingTransactionCompleted: "Event_ChargingTransactionCompleted",
    ConfirmMembershipInformProceed: "Event_ConfirmMembershipInformProceed",
    CoolioManualCommand: "Event_CoolioManualCommand",
    DiscoControlManualCommand: "Event_DiscoControlManualCommand",
    GenerateReceipt: "Event_GenerateReceipt",
    MembershipError: "Event_MembershipError",
    MembershipPresented: "Event_MembershipPresented",
    MembershipValidated: "Event_MembershipValidated",
    OcppIdTokenAuthorizationResolved: "Event_OcppIdTokenAuthorizationResolved",
    PaymentAuthorizationError: "Event_PaymentAuthorizationError",
    PaymentAuthorized: "Event_PaymentAuthorized",
    PaymentCancelled: "Event_PaymentCancelled",
    PaymentCaptureDeferred: "Event_PaymentCaptureDeferred",
    PaymentCaptureError: "Event_PaymentCaptureError",
    PaymentExpired: "Event_PaymentExpired",
    PaymentPresented: "Event_PaymentPresented",
    PaymentTerminalControlEMVCardPayload: "Event_PaymentTerminalControlEMVCardPayload",
    PaymentTerminalControlPaymentCompleted: "Event_PaymentTerminalControlPaymentCompleted",
    PaymentTerminalControlRequestCardPaymentCapture: "Event_PaymentTerminalControlRequestCardPaymentCapture",
    ReceivedOcpiTrackingId: "Event_ReceivedOcpiTrackingId",
    RegisterMemberIdentifier: "Event_RegisterMemberIdentifier",
    RequestMembershipValidation: "Event_RequestMembershipValidation",
    RequestOcppIdTokenAuthorization: "Event_RequestOcppIdTokenAuthorization",
    SimChargerControlDeratingReason: "Event_SimChargerControlDeratingReason",
    SimChargerControlErrorCode: "Event_SimChargerControlErrorCode",
    SimChargerControlPluggedIn: "Event_SimChargerControlPluggedIn",
    SimPaymentTerminalControlPayment: "Event_SimPaymentTerminalControlPayment",
    SkipMembershipValidation: "Event_SkipMembershipValidation",
    SksgV2FirmwareUpdateCommand: "Event_SksgV2FirmwareUpdateCommand",
    SksgV2RebootCommand: "Event_SksgV2RebootCommand",
    StopChargingSessionRequest: "Event_StopChargingSessionRequest",
    UseMembershipAsPayment: "Event_UseMembershipAsPayment",
};
exports.StateTopics = {
    ChargerControlActiveSessionAttempts: "State_ChargerControlActiveSessionAttempts",
    ChargerControlActiveTransactions: "State_ChargerControlActiveTransactions",
    ChargerControlChargerConfiguration: "State_ChargerControlChargerConfiguration",
    ChargerControlChargerStatus: "State_ChargerControlChargerStatus",
    ChargerControlCharging: "State_ChargerControlCharging",
    ChargerControlCloudChargerOperatingStatus: "State_ChargerControlCloudChargerOperatingStatus",
    ChargerControlCtepParameterLog: "State_ChargerControlCtepParameterLog",
    ChargerControlOcppAuthorizedTransactions: "State_ChargerControlOcppAuthorizedTransactions",
    ChargerControlPricing: "State_ChargerControlPricing",
    ChargerControlTransactionStatus: "State_ChargerControlTransactionStatus",
    ChargerControlUIScreenStatus: "State_ChargerControlUIScreenStatus",
    ChargerUIActivePort: "State_ChargerUIActivePort",
    ChargerUIFullscreenTakeover: "State_ChargerUIFullscreenTakeover",
    ChargerUIStatus: "State_ChargerUIStatus",
    ChargingSessionTracker: "State_ChargingSessionTracker",
    ChargingTransactionTelemetryTracker: "State_ChargingTransactionTelemetryTracker",
    PaymentTerminalControlActiveMemberships: "State_PaymentTerminalControlActiveMemberships",
    PaymentTerminalControlActivePayments: "State_PaymentTerminalControlActivePayments",
    PaymentTerminalControlCachedPaymentMethod: "State_PaymentTerminalControlCachedPaymentMethod",
    PaymentTerminalControlCompletedPayments: "State_PaymentTerminalControlCompletedPayments",
    PaymentTerminalControlMetrics: "State_PaymentTerminalControlMetrics",
    PaymentTerminalControlPendingPreauths: "State_PaymentTerminalControlPendingPreauths",
    PaymentTerminalControlPresentedPayments: "State_PaymentTerminalControlPresentedPayments",
    PaymentTerminalControlProcessingPayments: "State_PaymentTerminalControlProcessingPayments",
    PaymentTerminalControlTerminalStatus: "State_PaymentTerminalControlTerminalStatus",
    ReceiptChargingSessionAttempts: "State_ReceiptChargingSessionAttempts",
    SimDispenserControlEvseCommands: "State_SimDispenserControlEvseCommands",
    SimDispenserControlHvPs: "State_SimDispenserControlHvPs",
    SimDispenserControlSafetyMicro: "State_SimDispenserControlSafetyMicro",
    TestRackEvGpioCommand: "State_TestRackEvGpioCommand",
    TestRackEvStatus: "State_TestRackEvStatus",
    TestRackPowerSinkCommand: "State_TestRackPowerSinkCommand",
    TestRackPowerSinkStatus: "State_TestRackPowerSinkStatus",
    TestRackPowerSourceCommand: "State_TestRackPowerSourceCommand",
    TestRackPowerSourceStatus: "State_TestRackPowerSourceStatus",
    TestRackRelayCommand: "State_TestRackRelayCommand",
    TestRackRelayStatus: "State_TestRackRelayStatus",
};
/**
 * Auto-generated typed serialization functions for events.
 */
function serializeCancelTransactionEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PortRequestSerialization.serialize);
}
exports.serializeCancelTransactionEvent = serializeCancelTransactionEvent;
function serializeChargerControlPluggedInEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargerControlChargingPortStateSerialization.serialize);
}
exports.serializeChargerControlPluggedInEvent = serializeChargerControlPluggedInEvent;
function serializeChargerUIChangeActivePortEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargerUIActivePortSerialization.serialize);
}
exports.serializeChargerUIChangeActivePortEvent = serializeChargerUIChangeActivePortEvent;
function serializeChargerUISendFeedbackEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargerUISendFeedbackSerialization.serialize);
}
exports.serializeChargerUISendFeedbackEvent = serializeChargerUISendFeedbackEvent;
function serializeChargerUISendOnScreenValidationFeedbackEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargerUISendOnScreenValidationFeedbackSerialization.serialize);
}
exports.serializeChargerUISendOnScreenValidationFeedbackEvent = serializeChargerUISendOnScreenValidationFeedbackEvent;
function serializeChargingTransactionCompletedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargingSessionAttemptSerialization.serialize);
}
exports.serializeChargingTransactionCompletedEvent = serializeChargingTransactionCompletedEvent;
function serializeConfirmMembershipInformProceedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PortRequestSerialization.serialize);
}
exports.serializeConfirmMembershipInformProceedEvent = serializeConfirmMembershipInformProceedEvent;
function serializeCoolioManualCommandEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.CoolioManualCommandsSerialization.serialize);
}
exports.serializeCoolioManualCommandEvent = serializeCoolioManualCommandEvent;
function serializeDiscoControlManualCommandEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.DispenserControlManualCommandsSerialization.serialize);
}
exports.serializeDiscoControlManualCommandEvent = serializeDiscoControlManualCommandEvent;
function serializeGenerateReceiptEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.GenerateReceiptSerialization.serialize);
}
exports.serializeGenerateReceiptEvent = serializeGenerateReceiptEvent;
function serializeMembershipErrorEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.MembershipTransactionSerialization.serialize);
}
exports.serializeMembershipErrorEvent = serializeMembershipErrorEvent;
function serializeMembershipPresentedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.MembershipTransactionSerialization.serialize);
}
exports.serializeMembershipPresentedEvent = serializeMembershipPresentedEvent;
function serializeMembershipValidatedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.MembershipTransactionSerialization.serialize);
}
exports.serializeMembershipValidatedEvent = serializeMembershipValidatedEvent;
function serializeOcppIdTokenAuthorizationResolvedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.OcppIdTokenAuthorizationSerialization.serialize);
}
exports.serializeOcppIdTokenAuthorizationResolvedEvent = serializeOcppIdTokenAuthorizationResolvedEvent;
function serializePaymentAuthorizationErrorEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentAuthorizationErrorEvent = serializePaymentAuthorizationErrorEvent;
function serializePaymentAuthorizedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentAuthorizedEvent = serializePaymentAuthorizedEvent;
function serializePaymentCancelledEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentCancelledEvent = serializePaymentCancelledEvent;
function serializePaymentCaptureDeferredEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentCaptureDeferredEvent = serializePaymentCaptureDeferredEvent;
function serializePaymentCaptureErrorEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentCaptureErrorEvent = serializePaymentCaptureErrorEvent;
function serializePaymentExpiredEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentExpiredEvent = serializePaymentExpiredEvent;
function serializePaymentPresentedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentPresentedEvent = serializePaymentPresentedEvent;
function serializePaymentTerminalControlEMVCardPayloadEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTerminalControlEMVCardPayloadSerialization.serialize);
}
exports.serializePaymentTerminalControlEMVCardPayloadEvent = serializePaymentTerminalControlEMVCardPayloadEvent;
function serializePaymentTerminalControlPaymentCompletedEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentTerminalControlPaymentCompletedEvent = serializePaymentTerminalControlPaymentCompletedEvent;
function serializePaymentTerminalControlRequestCardPaymentCaptureEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PaymentTransactionSerialization.serialize);
}
exports.serializePaymentTerminalControlRequestCardPaymentCaptureEvent = serializePaymentTerminalControlRequestCardPaymentCaptureEvent;
function serializeReceivedOcpiTrackingIdEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ReceivedOcpiTrackingIdSerialization.serialize);
}
exports.serializeReceivedOcpiTrackingIdEvent = serializeReceivedOcpiTrackingIdEvent;
function serializeRegisterMemberIdentifierEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.MembershipIdentifierSubmissionSerialization.serialize);
}
exports.serializeRegisterMemberIdentifierEvent = serializeRegisterMemberIdentifierEvent;
function serializeRequestMembershipValidationEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.MembershipIdentifierSubmissionSerialization.serialize);
}
exports.serializeRequestMembershipValidationEvent = serializeRequestMembershipValidationEvent;
function serializeRequestOcppIdTokenAuthorizationEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.OcppIdTokenAuthorizationSerialization.serialize);
}
exports.serializeRequestOcppIdTokenAuthorizationEvent = serializeRequestOcppIdTokenAuthorizationEvent;
function serializeSimChargerControlDeratingReasonEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.SimChargerControlDeratingReasonStateSerialization.serialize);
}
exports.serializeSimChargerControlDeratingReasonEvent = serializeSimChargerControlDeratingReasonEvent;
function serializeSimChargerControlErrorCodeEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.SimChargerControlErrorCodeStateSerialization.serialize);
}
exports.serializeSimChargerControlErrorCodeEvent = serializeSimChargerControlErrorCodeEvent;
function serializeSimChargerControlPluggedInEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.ChargerControlChargingPortStateSerialization.serialize);
}
exports.serializeSimChargerControlPluggedInEvent = serializeSimChargerControlPluggedInEvent;
function serializeSimPaymentTerminalControlPaymentEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.SimulationPaymentSerialization.serialize);
}
exports.serializeSimPaymentTerminalControlPaymentEvent = serializeSimPaymentTerminalControlPaymentEvent;
function serializeSkipMembershipValidationEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PortRequestSerialization.serialize);
}
exports.serializeSkipMembershipValidationEvent = serializeSkipMembershipValidationEvent;
function serializeSksgV2FirmwareUpdateCommandEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.SksgV2FirmwareUpdateCommandSerialization.serialize);
}
exports.serializeSksgV2FirmwareUpdateCommandEvent = serializeSksgV2FirmwareUpdateCommandEvent;
function serializeSksgV2RebootCommandEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.SksgV2RebootCommandSerialization.serialize);
}
exports.serializeSksgV2RebootCommandEvent = serializeSksgV2RebootCommandEvent;
function serializeStopChargingSessionRequestEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PortRequestSerialization.serialize);
}
exports.serializeStopChargingSessionRequestEvent = serializeStopChargingSessionRequestEvent;
function serializeUseMembershipAsPaymentEvent(event) {
    return (0, __1.serializeEvent)(event, serialization_1.PortRequestSerialization.serialize);
}
exports.serializeUseMembershipAsPaymentEvent = serializeUseMembershipAsPaymentEvent;
/**
 * Auto-generated typed serialization functions for states.
 */
function serializeChargerControlActiveSessionAttemptsState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlActiveSessionAttemptsSerialization.serialize);
}
exports.serializeChargerControlActiveSessionAttemptsState = serializeChargerControlActiveSessionAttemptsState;
function serializeChargerControlActiveTransactionsState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlActiveTransactionsSerialization.serialize);
}
exports.serializeChargerControlActiveTransactionsState = serializeChargerControlActiveTransactionsState;
function serializeChargerControlChargerConfigurationState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerConfigurationSerialization.serialize);
}
exports.serializeChargerControlChargerConfigurationState = serializeChargerControlChargerConfigurationState;
function serializeChargerControlChargerStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerStatusSerialization.serialize);
}
exports.serializeChargerControlChargerStatusState = serializeChargerControlChargerStatusState;
function serializeChargerControlChargingState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlChargingSerialization.serialize);
}
exports.serializeChargerControlChargingState = serializeChargerControlChargingState;
function serializeChargerControlCloudChargerOperatingStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.CloudChargerOperatingStatusSerialization.serialize);
}
exports.serializeChargerControlCloudChargerOperatingStatusState = serializeChargerControlCloudChargerOperatingStatusState;
function serializeChargerControlCtepParameterLogState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlCtepParameterLogSerialization.serialize);
}
exports.serializeChargerControlCtepParameterLogState = serializeChargerControlCtepParameterLogState;
function serializeChargerControlOcppAuthorizedTransactionsState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlOcppAuthorizedTransactionsSerialization.serialize);
}
exports.serializeChargerControlOcppAuthorizedTransactionsState = serializeChargerControlOcppAuthorizedTransactionsState;
function serializeChargerControlPricingState(state) {
    return (0, __1.serializeState)(state, serialization_1.money_PricingModelSerialization.serialize);
}
exports.serializeChargerControlPricingState = serializeChargerControlPricingState;
function serializeChargerControlTransactionStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlTransactionStatusSerialization.serialize);
}
exports.serializeChargerControlTransactionStatusState = serializeChargerControlTransactionStatusState;
function serializeChargerControlUIScreenStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerControlUIScreenStatusSerialization.serialize);
}
exports.serializeChargerControlUIScreenStatusState = serializeChargerControlUIScreenStatusState;
function serializeChargerUIActivePortState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerUIActivePortSerialization.serialize);
}
exports.serializeChargerUIActivePortState = serializeChargerUIActivePortState;
function serializeChargerUIFullscreenTakeoverState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerUIFullscreenTakeoverSerialization.serialize);
}
exports.serializeChargerUIFullscreenTakeoverState = serializeChargerUIFullscreenTakeoverState;
function serializeChargerUIStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargerUIStatusSerialization.serialize);
}
exports.serializeChargerUIStatusState = serializeChargerUIStatusState;
function serializeChargingSessionTrackerState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargingSessionTrackerSerialization.serialize);
}
exports.serializeChargingSessionTrackerState = serializeChargingSessionTrackerState;
function serializeChargingTransactionTelemetryTrackerState(state) {
    return (0, __1.serializeState)(state, serialization_1.ChargingTransactionTelemetryTrackerSerialization.serialize);
}
exports.serializeChargingTransactionTelemetryTrackerState = serializeChargingTransactionTelemetryTrackerState;
function serializePaymentTerminalControlActiveMembershipsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlActiveMembershipsSerialization.serialize);
}
exports.serializePaymentTerminalControlActiveMembershipsState = serializePaymentTerminalControlActiveMembershipsState;
function serializePaymentTerminalControlActivePaymentsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlActivePaymentsSerialization.serialize);
}
exports.serializePaymentTerminalControlActivePaymentsState = serializePaymentTerminalControlActivePaymentsState;
function serializePaymentTerminalControlCachedPaymentMethodState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlCachedPaymentSerialization.serialize);
}
exports.serializePaymentTerminalControlCachedPaymentMethodState = serializePaymentTerminalControlCachedPaymentMethodState;
function serializePaymentTerminalControlCompletedPaymentsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlCompletedPaymentsSerialization.serialize);
}
exports.serializePaymentTerminalControlCompletedPaymentsState = serializePaymentTerminalControlCompletedPaymentsState;
function serializePaymentTerminalControlMetricsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlMetricsSerialization.serialize);
}
exports.serializePaymentTerminalControlMetricsState = serializePaymentTerminalControlMetricsState;
function serializePaymentTerminalControlPendingPreauthsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlPendingPreauthsSerialization.serialize);
}
exports.serializePaymentTerminalControlPendingPreauthsState = serializePaymentTerminalControlPendingPreauthsState;
function serializePaymentTerminalControlPresentedPaymentsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlPresentedPaymentsSerialization.serialize);
}
exports.serializePaymentTerminalControlPresentedPaymentsState = serializePaymentTerminalControlPresentedPaymentsState;
function serializePaymentTerminalControlProcessingPaymentsState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlProcessingPaymentsSerialization.serialize);
}
exports.serializePaymentTerminalControlProcessingPaymentsState = serializePaymentTerminalControlProcessingPaymentsState;
function serializePaymentTerminalControlTerminalStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.PaymentTerminalControlTerminalStatusSerialization.serialize);
}
exports.serializePaymentTerminalControlTerminalStatusState = serializePaymentTerminalControlTerminalStatusState;
function serializeReceiptChargingSessionAttemptsState(state) {
    return (0, __1.serializeState)(state, serialization_1.ReceiptChargingSessionAttemptsSerialization.serialize);
}
exports.serializeReceiptChargingSessionAttemptsState = serializeReceiptChargingSessionAttemptsState;
function serializeSimDispenserControlEvseCommandsState(state) {
    return (0, __1.serializeState)(state, serialization_1.SimDispenserControlEvseCommandsSerialization.serialize);
}
exports.serializeSimDispenserControlEvseCommandsState = serializeSimDispenserControlEvseCommandsState;
function serializeSimDispenserControlHvPsState(state) {
    return (0, __1.serializeState)(state, serialization_1.SimDispenserControlHvPsOutSerialization.serialize);
}
exports.serializeSimDispenserControlHvPsState = serializeSimDispenserControlHvPsState;
function serializeSimDispenserControlSafetyMicroState(state) {
    return (0, __1.serializeState)(state, serialization_1.SimDispenserControlSafetyMicroOutSerialization.serialize);
}
exports.serializeSimDispenserControlSafetyMicroState = serializeSimDispenserControlSafetyMicroState;
function serializeTestRackEvGpioCommandState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackEvGpioCommandSerialization.serialize);
}
exports.serializeTestRackEvGpioCommandState = serializeTestRackEvGpioCommandState;
function serializeTestRackEvStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackEvStatusSerialization.serialize);
}
exports.serializeTestRackEvStatusState = serializeTestRackEvStatusState;
function serializeTestRackPowerSinkCommandState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackPowerCommandSerialization.serialize);
}
exports.serializeTestRackPowerSinkCommandState = serializeTestRackPowerSinkCommandState;
function serializeTestRackPowerSinkStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackPowerStatusSerialization.serialize);
}
exports.serializeTestRackPowerSinkStatusState = serializeTestRackPowerSinkStatusState;
function serializeTestRackPowerSourceCommandState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackPowerCommandSerialization.serialize);
}
exports.serializeTestRackPowerSourceCommandState = serializeTestRackPowerSourceCommandState;
function serializeTestRackPowerSourceStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackPowerStatusSerialization.serialize);
}
exports.serializeTestRackPowerSourceStatusState = serializeTestRackPowerSourceStatusState;
function serializeTestRackRelayCommandState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackRelaysSerialization.serialize);
}
exports.serializeTestRackRelayCommandState = serializeTestRackRelayCommandState;
function serializeTestRackRelayStatusState(state) {
    return (0, __1.serializeState)(state, serialization_1.TestRackRelaysSerialization.serialize);
}
exports.serializeTestRackRelayStatusState = serializeTestRackRelayStatusState;
/**
 * Serializes an event by entity type name and returns topic and payload.
 * @param entityType - The entity type name (e.g., "CoolioManualCommand")
 * @param entity - The parsed entity object
 * @param originator - The originator identifier
 * @returns Object with topic and serialized payload
 * @throws Error if entity type is unknown
 */
function serializeEventByEntityType(entityType, entity, originator) {
    const event = {
        entity,
        event_timestamp: new Date(),
        originator,
    };
    switch (entityType) {
        case "CancelTransaction":
            return {
                topic: exports.EventTopics.CancelTransaction,
                payload: serializeCancelTransactionEvent(event),
            };
        case "ChargerControlPluggedIn":
            return {
                topic: exports.EventTopics.ChargerControlPluggedIn,
                payload: serializeChargerControlPluggedInEvent(event),
            };
        case "ChargerUIChangeActivePort":
            return {
                topic: exports.EventTopics.ChargerUIChangeActivePort,
                payload: serializeChargerUIChangeActivePortEvent(event),
            };
        case "ChargerUISendFeedback":
            return {
                topic: exports.EventTopics.ChargerUISendFeedback,
                payload: serializeChargerUISendFeedbackEvent(event),
            };
        case "ChargerUISendOnScreenValidationFeedback":
            return {
                topic: exports.EventTopics.ChargerUISendOnScreenValidationFeedback,
                payload: serializeChargerUISendOnScreenValidationFeedbackEvent(event),
            };
        case "ChargingTransactionCompleted":
            return {
                topic: exports.EventTopics.ChargingTransactionCompleted,
                payload: serializeChargingTransactionCompletedEvent(event),
            };
        case "ConfirmMembershipInformProceed":
            return {
                topic: exports.EventTopics.ConfirmMembershipInformProceed,
                payload: serializeConfirmMembershipInformProceedEvent(event),
            };
        case "CoolioManualCommand":
            return {
                topic: exports.EventTopics.CoolioManualCommand,
                payload: serializeCoolioManualCommandEvent(event),
            };
        case "DiscoControlManualCommand":
            return {
                topic: exports.EventTopics.DiscoControlManualCommand,
                payload: serializeDiscoControlManualCommandEvent(event),
            };
        case "GenerateReceipt":
            return {
                topic: exports.EventTopics.GenerateReceipt,
                payload: serializeGenerateReceiptEvent(event),
            };
        case "MembershipError":
            return {
                topic: exports.EventTopics.MembershipError,
                payload: serializeMembershipErrorEvent(event),
            };
        case "MembershipPresented":
            return {
                topic: exports.EventTopics.MembershipPresented,
                payload: serializeMembershipPresentedEvent(event),
            };
        case "MembershipValidated":
            return {
                topic: exports.EventTopics.MembershipValidated,
                payload: serializeMembershipValidatedEvent(event),
            };
        case "OcppIdTokenAuthorizationResolved":
            return {
                topic: exports.EventTopics.OcppIdTokenAuthorizationResolved,
                payload: serializeOcppIdTokenAuthorizationResolvedEvent(event),
            };
        case "PaymentAuthorizationError":
            return {
                topic: exports.EventTopics.PaymentAuthorizationError,
                payload: serializePaymentAuthorizationErrorEvent(event),
            };
        case "PaymentAuthorized":
            return {
                topic: exports.EventTopics.PaymentAuthorized,
                payload: serializePaymentAuthorizedEvent(event),
            };
        case "PaymentCancelled":
            return {
                topic: exports.EventTopics.PaymentCancelled,
                payload: serializePaymentCancelledEvent(event),
            };
        case "PaymentCaptureDeferred":
            return {
                topic: exports.EventTopics.PaymentCaptureDeferred,
                payload: serializePaymentCaptureDeferredEvent(event),
            };
        case "PaymentCaptureError":
            return {
                topic: exports.EventTopics.PaymentCaptureError,
                payload: serializePaymentCaptureErrorEvent(event),
            };
        case "PaymentExpired":
            return {
                topic: exports.EventTopics.PaymentExpired,
                payload: serializePaymentExpiredEvent(event),
            };
        case "PaymentPresented":
            return {
                topic: exports.EventTopics.PaymentPresented,
                payload: serializePaymentPresentedEvent(event),
            };
        case "PaymentTerminalControlEMVCardPayload":
            return {
                topic: exports.EventTopics.PaymentTerminalControlEMVCardPayload,
                payload: serializePaymentTerminalControlEMVCardPayloadEvent(event),
            };
        case "PaymentTerminalControlPaymentCompleted":
            return {
                topic: exports.EventTopics.PaymentTerminalControlPaymentCompleted,
                payload: serializePaymentTerminalControlPaymentCompletedEvent(event),
            };
        case "PaymentTerminalControlRequestCardPaymentCapture":
            return {
                topic: exports.EventTopics.PaymentTerminalControlRequestCardPaymentCapture,
                payload: serializePaymentTerminalControlRequestCardPaymentCaptureEvent(event),
            };
        case "ReceivedOcpiTrackingId":
            return {
                topic: exports.EventTopics.ReceivedOcpiTrackingId,
                payload: serializeReceivedOcpiTrackingIdEvent(event),
            };
        case "RegisterMemberIdentifier":
            return {
                topic: exports.EventTopics.RegisterMemberIdentifier,
                payload: serializeRegisterMemberIdentifierEvent(event),
            };
        case "RequestMembershipValidation":
            return {
                topic: exports.EventTopics.RequestMembershipValidation,
                payload: serializeRequestMembershipValidationEvent(event),
            };
        case "RequestOcppIdTokenAuthorization":
            return {
                topic: exports.EventTopics.RequestOcppIdTokenAuthorization,
                payload: serializeRequestOcppIdTokenAuthorizationEvent(event),
            };
        case "SimChargerControlDeratingReason":
            return {
                topic: exports.EventTopics.SimChargerControlDeratingReason,
                payload: serializeSimChargerControlDeratingReasonEvent(event),
            };
        case "SimChargerControlErrorCode":
            return {
                topic: exports.EventTopics.SimChargerControlErrorCode,
                payload: serializeSimChargerControlErrorCodeEvent(event),
            };
        case "SimChargerControlPluggedIn":
            return {
                topic: exports.EventTopics.SimChargerControlPluggedIn,
                payload: serializeSimChargerControlPluggedInEvent(event),
            };
        case "SimPaymentTerminalControlPayment":
            return {
                topic: exports.EventTopics.SimPaymentTerminalControlPayment,
                payload: serializeSimPaymentTerminalControlPaymentEvent(event),
            };
        case "SkipMembershipValidation":
            return {
                topic: exports.EventTopics.SkipMembershipValidation,
                payload: serializeSkipMembershipValidationEvent(event),
            };
        case "SksgV2FirmwareUpdateCommand":
            return {
                topic: exports.EventTopics.SksgV2FirmwareUpdateCommand,
                payload: serializeSksgV2FirmwareUpdateCommandEvent(event),
            };
        case "SksgV2RebootCommand":
            return {
                topic: exports.EventTopics.SksgV2RebootCommand,
                payload: serializeSksgV2RebootCommandEvent(event),
            };
        case "StopChargingSessionRequest":
            return {
                topic: exports.EventTopics.StopChargingSessionRequest,
                payload: serializeStopChargingSessionRequestEvent(event),
            };
        case "UseMembershipAsPayment":
            return {
                topic: exports.EventTopics.UseMembershipAsPayment,
                payload: serializeUseMembershipAsPaymentEvent(event),
            };
        default:
            throw new Error(`Unknown entity type: ${entityType}`);
    }
}
exports.serializeEventByEntityType = serializeEventByEntityType;
/**
 * Serializes a state by entity type name and returns topic and payload.
 * @param entityType - The entity type name (e.g., "ChargerControlCharging")
 * @param entity - The parsed entity object
 * @param originator - The originator identifier
 * @returns Object with topic and serialized payload
 * @throws Error if entity type is unknown
 */
function serializeStateByEntityType(entityType, entity, originator) {
    const state = {
        entity,
        state_timestamp: new Date(),
        originator,
    };
    switch (entityType) {
        case "ChargerControlActiveSessionAttempts":
            return {
                topic: exports.StateTopics.ChargerControlActiveSessionAttempts,
                payload: serializeChargerControlActiveSessionAttemptsState(state),
            };
        case "ChargerControlActiveTransactions":
            return {
                topic: exports.StateTopics.ChargerControlActiveTransactions,
                payload: serializeChargerControlActiveTransactionsState(state),
            };
        case "ChargerControlChargerConfiguration":
            return {
                topic: exports.StateTopics.ChargerControlChargerConfiguration,
                payload: serializeChargerControlChargerConfigurationState(state),
            };
        case "ChargerControlChargerStatus":
            return {
                topic: exports.StateTopics.ChargerControlChargerStatus,
                payload: serializeChargerControlChargerStatusState(state),
            };
        case "ChargerControlCharging":
            return {
                topic: exports.StateTopics.ChargerControlCharging,
                payload: serializeChargerControlChargingState(state),
            };
        case "ChargerControlCloudChargerOperatingStatus":
            return {
                topic: exports.StateTopics.ChargerControlCloudChargerOperatingStatus,
                payload: serializeChargerControlCloudChargerOperatingStatusState(state),
            };
        case "ChargerControlCtepParameterLog":
            return {
                topic: exports.StateTopics.ChargerControlCtepParameterLog,
                payload: serializeChargerControlCtepParameterLogState(state),
            };
        case "ChargerControlOcppAuthorizedTransactions":
            return {
                topic: exports.StateTopics.ChargerControlOcppAuthorizedTransactions,
                payload: serializeChargerControlOcppAuthorizedTransactionsState(state),
            };
        case "ChargerControlPricing":
            return {
                topic: exports.StateTopics.ChargerControlPricing,
                payload: serializeChargerControlPricingState(state),
            };
        case "ChargerControlTransactionStatus":
            return {
                topic: exports.StateTopics.ChargerControlTransactionStatus,
                payload: serializeChargerControlTransactionStatusState(state),
            };
        case "ChargerControlUIScreenStatus":
            return {
                topic: exports.StateTopics.ChargerControlUIScreenStatus,
                payload: serializeChargerControlUIScreenStatusState(state),
            };
        case "ChargerUIActivePort":
            return {
                topic: exports.StateTopics.ChargerUIActivePort,
                payload: serializeChargerUIActivePortState(state),
            };
        case "ChargerUIFullscreenTakeover":
            return {
                topic: exports.StateTopics.ChargerUIFullscreenTakeover,
                payload: serializeChargerUIFullscreenTakeoverState(state),
            };
        case "ChargerUIStatus":
            return {
                topic: exports.StateTopics.ChargerUIStatus,
                payload: serializeChargerUIStatusState(state),
            };
        case "ChargingSessionTracker":
            return {
                topic: exports.StateTopics.ChargingSessionTracker,
                payload: serializeChargingSessionTrackerState(state),
            };
        case "ChargingTransactionTelemetryTracker":
            return {
                topic: exports.StateTopics.ChargingTransactionTelemetryTracker,
                payload: serializeChargingTransactionTelemetryTrackerState(state),
            };
        case "PaymentTerminalControlActiveMemberships":
            return {
                topic: exports.StateTopics.PaymentTerminalControlActiveMemberships,
                payload: serializePaymentTerminalControlActiveMembershipsState(state),
            };
        case "PaymentTerminalControlActivePayments":
            return {
                topic: exports.StateTopics.PaymentTerminalControlActivePayments,
                payload: serializePaymentTerminalControlActivePaymentsState(state),
            };
        case "PaymentTerminalControlCachedPaymentMethod":
            return {
                topic: exports.StateTopics.PaymentTerminalControlCachedPaymentMethod,
                payload: serializePaymentTerminalControlCachedPaymentMethodState(state),
            };
        case "PaymentTerminalControlCompletedPayments":
            return {
                topic: exports.StateTopics.PaymentTerminalControlCompletedPayments,
                payload: serializePaymentTerminalControlCompletedPaymentsState(state),
            };
        case "PaymentTerminalControlMetrics":
            return {
                topic: exports.StateTopics.PaymentTerminalControlMetrics,
                payload: serializePaymentTerminalControlMetricsState(state),
            };
        case "PaymentTerminalControlPendingPreauths":
            return {
                topic: exports.StateTopics.PaymentTerminalControlPendingPreauths,
                payload: serializePaymentTerminalControlPendingPreauthsState(state),
            };
        case "PaymentTerminalControlPresentedPayments":
            return {
                topic: exports.StateTopics.PaymentTerminalControlPresentedPayments,
                payload: serializePaymentTerminalControlPresentedPaymentsState(state),
            };
        case "PaymentTerminalControlProcessingPayments":
            return {
                topic: exports.StateTopics.PaymentTerminalControlProcessingPayments,
                payload: serializePaymentTerminalControlProcessingPaymentsState(state),
            };
        case "PaymentTerminalControlTerminalStatus":
            return {
                topic: exports.StateTopics.PaymentTerminalControlTerminalStatus,
                payload: serializePaymentTerminalControlTerminalStatusState(state),
            };
        case "ReceiptChargingSessionAttempts":
            return {
                topic: exports.StateTopics.ReceiptChargingSessionAttempts,
                payload: serializeReceiptChargingSessionAttemptsState(state),
            };
        case "SimDispenserControlEvseCommands":
            return {
                topic: exports.StateTopics.SimDispenserControlEvseCommands,
                payload: serializeSimDispenserControlEvseCommandsState(state),
            };
        case "SimDispenserControlHvPs":
            return {
                topic: exports.StateTopics.SimDispenserControlHvPs,
                payload: serializeSimDispenserControlHvPsState(state),
            };
        case "SimDispenserControlSafetyMicro":
            return {
                topic: exports.StateTopics.SimDispenserControlSafetyMicro,
                payload: serializeSimDispenserControlSafetyMicroState(state),
            };
        case "TestRackEvGpioCommand":
            return {
                topic: exports.StateTopics.TestRackEvGpioCommand,
                payload: serializeTestRackEvGpioCommandState(state),
            };
        case "TestRackEvStatus":
            return {
                topic: exports.StateTopics.TestRackEvStatus,
                payload: serializeTestRackEvStatusState(state),
            };
        case "TestRackPowerSinkCommand":
            return {
                topic: exports.StateTopics.TestRackPowerSinkCommand,
                payload: serializeTestRackPowerSinkCommandState(state),
            };
        case "TestRackPowerSinkStatus":
            return {
                topic: exports.StateTopics.TestRackPowerSinkStatus,
                payload: serializeTestRackPowerSinkStatusState(state),
            };
        case "TestRackPowerSourceCommand":
            return {
                topic: exports.StateTopics.TestRackPowerSourceCommand,
                payload: serializeTestRackPowerSourceCommandState(state),
            };
        case "TestRackPowerSourceStatus":
            return {
                topic: exports.StateTopics.TestRackPowerSourceStatus,
                payload: serializeTestRackPowerSourceStatusState(state),
            };
        case "TestRackRelayCommand":
            return {
                topic: exports.StateTopics.TestRackRelayCommand,
                payload: serializeTestRackRelayCommandState(state),
            };
        case "TestRackRelayStatus":
            return {
                topic: exports.StateTopics.TestRackRelayStatus,
                payload: serializeTestRackRelayStatusState(state),
            };
        default:
            throw new Error(`Unknown entity type: ${entityType}`);
    }
}
exports.serializeStateByEntityType = serializeStateByEntityType;
